import { Component, Input } from '@angular/core';

import { SearchActivityEvents } from 'generated/graphql';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

@Component({
  selector: 'app-mass-add-assessment-event',
  templateUrl: './mass-add-assessment-event.component.html'
})

export class ASMassAddAssessmentEventComponent extends
  WithDisposableSubject()  {

  @Input() item: SearchActivityEvents.Node;

  get payload() {
    return this.item?.payload;
  }

  /**
   *
   */
  constructor() {
    super();
  }


}


